import style from "./savedSearch.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const SavedItem = ({ title, url, removeSaved }) => {
  return (
    <>
      <div className={classNames("size-14", style.savedSearchContainer)}>
        <a className={style.savedLink} href={url}>
          {title}
        </a>
        <button
          className={style.removeSavedButton}
          type="button"
          onClick={removeSaved}
          data-testid="removeAddSaveButton"
        >
          <i className="tg-icons-Cross size-20"></i>
        </button>
      </div>
    </>
  );
};

SavedItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  removeSaved: PropTypes.func.isRequired,
};

export default SavedItem;
